import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";

import Style from "@client/utils/Style";

const Wrapper = styled.div`
  width: 94px;
  height: 14px;
  line-height: 14px;
  border: 1px solid;
  font-size: 9px;
  font-weight: ${Style.fontWeights.medium};
  text-align: center;
  border-radius: 4px;
  text-transform: uppercase;
`;

type Props = {
  label: string;
  borderColor?: string;
  backgroundColor?: string;
  fontColor?: string;
  style?: any;
};
@observer
class StatusPill extends React.Component<Props> {
  render() {
    return (
      <Wrapper
        style={{
          borderColor: this.props.borderColor || "transparent",
          backgroundColor:
            this.props.backgroundColor || Style.palette.primaryHighlight,
          color: this.props.fontColor || "white",
          ...this.props.style,
        }}
      >
        {this.props.label}
      </Wrapper>
    );
  }
}

export default StatusPill;
